module.exports = __webpack_public_path__ + "img/ics_o_barcode.d9e0cb1f.svg";